import { inventoryTransformer } from '../../transformers/global/index.js';
import { getCDLVehicleTransformer } from '../../transformers/pixall/inventoryTransformer.js';
export default function createCoxAutoDataLayer(_ref) {
  let {
    dataLayer = {}
  } = _ref;
  window.coxAutoDataLayer = window.coxAutoDataLayer || [];
  const {
    common = {},
    consumerInsights,
    consumerAdTargetsWithoutCAMPBias,
    consumerAdTargets,
    consumerMarketingSegments,
    editorial,
    syc,
    service,
    vehicle,
    ico,
    user = {},
    page: dataLayerPage = {},
    search,
    cdlApplication = {},
    client,
    pixall
  } = dataLayer;
  const {
    siteSection,
    cdlSiteSection,
    pageType,
    detailPageName,
    cdlDetailPageName,
    type
  } = dataLayerPage ?? {};
  const commonDataLayer = {
    application: {
      name: cdlApplication?.name,
      componentId: cdlApplication?.componentId
    },
    client,
    pixall,
    page: {
      hierarchy: [siteSection, pageType, cdlDetailPageName || detailPageName],
      type,
      siteSection: cdlSiteSection
    },
    user: {
      isInternalUser: String(!!common.user?.isInternalUser),
      logInSource: String(user.isLoggedIn),
      zipCode: user?.zipCode
    },
    search: {
      zipCode: search?.zipCode
    },
    peSnapshotId: null
  };
  if (consumerAdTargetsWithoutCAMPBias) {
    commonDataLayer.consumerAdTargetsWithoutCAMPBias = {
      preferredModel: consumerAdTargetsWithoutCAMPBias.preferredModel,
      secondPreferredModel: consumerAdTargetsWithoutCAMPBias.secondPreferredModel,
      preferredMakes: consumerAdTargetsWithoutCAMPBias.preferredMakes,
      subCategory: consumerAdTargetsWithoutCAMPBias.subCategory,
      intent: consumerAdTargetsWithoutCAMPBias.intent,
      tradeInMake: consumerAdTargetsWithoutCAMPBias.tradeInMake,
      tradeInModel: consumerAdTargetsWithoutCAMPBias.tradeInModel
    };
  }
  if (consumerAdTargets) {
    commonDataLayer.consumerAdTargets = {
      consumerAdTargetInsightsAvailable: consumerAdTargets.consumerAdTargetInsightsAvailable,
      consumerCampaignPreferencesAddedByRule: consumerAdTargets.consumerCampaignPreferencesAddedByRule
    };
  }
  if (consumerMarketingSegments) {
    commonDataLayer.consumerMarketingSegments = {
      demographics: consumerMarketingSegments.demographics,
      lifeevents: consumerMarketingSegments.lifeEvents,
      clusters: consumerMarketingSegments.clusters
    };
  }
  if (consumerInsights) {
    commonDataLayer.consumerInsights = {
      apiTrackingId: consumerInsights.apiTrackingId,
      fixedOps: consumerInsights.fixedOps,
      makeBodystyleLoyalty: consumerInsights.makeBodystyleLoyalty,
      marketLevel: consumerInsights.marketLevel,
      marketLevelConfidence: consumerInsights.marketLevelConfidence,
      preferredBodystyle: consumerInsights.preferredBodystyle,
      preferredBodystyleConfidence: consumerInsights.preferredBodystyleConfidence,
      preferredMake: consumerInsights.preferredMake,
      preferredMakeConfidence: consumerInsights.preferredMakeConfidence,
      preferredMileage: consumerInsights.preferredMileage,
      preferredMileageConfidence: consumerInsights.preferredMileageConfidence,
      preferredModel: consumerInsights.preferredModel,
      preferredModelConfidence: consumerInsights.preferredModelConfidence,
      preferredPrice: consumerInsights.preferredPrice,
      preferredPriceConfidence: consumerInsights.preferredPriceConfidence,
      preferredVehicleType: consumerInsights.preferredVehicleType,
      preferredVehicleTypeConfidence: consumerInsights.preferredVehicleTypeConfidence,
      priceSensitivity: consumerInsights.priceSensitivity,
      recentActivityPreferredMake: consumerInsights.recentActivityPreferredMake,
      recentActivityPreferredModel: consumerInsights.recentActivityPreferredModel,
      secondPreferredFuelCategory: consumerInsights.secondPreferredFuelCategory,
      secondPreferredMake: consumerInsights.secondPreferredMake,
      secondPreferredModel: consumerInsights.secondPreferredModel
    };
  }
  if (editorial) {
    commonDataLayer.editorial = {
      author: editorial.author,
      modifiedDate: editorial.modifiedDate,
      publishedDate: editorial.publishedDate,
      searchKeywords: editorial.searchKeywords
    };
  }
  if (syc) {
    commonDataLayer.syc = {
      purchaseOrEditPath: syc.purchasePath,
      orderId: syc.orderId
    };
  }
  if (ico) {
    commonDataLayer.ico = {
      offerCode: ico.offerCode,
      optionToSell: ico.optionToSell,
      entryPoint: ico.entryPoint,
      responseFields: ico.responseFields,
      responseValues: ico.responseValues,
      path: ico.path,
      offerStatus: ico.offerStatus,
      filterResults: ico.filterResults,
      searchDetails: ico.searchDetails,
      profileId: ico.profileID,
      vehicleEntry: ico.vehicleEntry,
      offerId: ico.offerId
    };
  }
  if (vehicle) {
    const vehicleTransformer = inventoryTransformer(vehicle, {
      target: 'vehicle',
      dataLayer
    });
    const additionalMapping = {
      bodyStyle: 'bodyStyle',
      chromeStyleId: 'chromeStyleId',
      listingAccountId: 'listingId',
      listingPriorityType: 'priorityType',
      make: 'makeName',
      model: 'modelName',
      type: 'vehicleType',
      vin: 'vin',
      year: 'year'
      // Still need to map product and listingTrigger but I don't see them in vehicle object
    };
    commonDataLayer.vehicle = {
      ...getCDLVehicleTransformer(vehicleTransformer, additionalMapping),
      listingType: vehicle?.listingType
    };
  }
  if (search) {
    const {
      filters = {}
    } = search;
    commonDataLayer.vehicleSearch = {
      searchKeywords: filters.keywordPhrases || {
        makeCode: filters.makeCode,
        modelCode: filters.modelCode
      },
      vehicleHistory: filters.vehicleHistoryType,
      vehicleSellerType: filters.sellerType,
      atHomeVehicleServices: filters.homeServices
    };
  }
  if (service) {
    commonDataLayer.service = {
      customerSource: service.customerSource
    };
  }
  window.coxAutoDataLayer.push(commonDataLayer);
}